import { speechReportApi } from '../apis';

class SpeechReportService {
  async postSpeechRecord(data) {
    const rs = await speechReportApi.postSpeechRecord(data);
    return rs;
  }

  async getSpeechRecordScripts() {
    const rs = await speechReportApi.getSpeechRecordScripts();
    return rs;
  }

  async callNoiseEnhanceApi(data) {
    const rs = await speechReportApi.callNoiseEnhanceApi(data);
    return rs;
  }
}

const speechReportService = new SpeechReportService();

export default speechReportService;
